export enum EngagementDocumentStatus {
    PostedForViewing = 0,
    RequiresAction = 1,
    Completed = 2,
}

export const EngagementDocumentStatusOptions = {
    [EngagementDocumentStatus.PostedForViewing]: 'Viewable',
    [EngagementDocumentStatus.RequiresAction]: 'Requires Action',
    [EngagementDocumentStatus.Completed]: 'Complete',
};